var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptLongBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-40p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_21125",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.664062,
    y: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_21125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "receipt_long",
    d: "M10.9128 36.4C9.73259 36.4 8.72941 35.9869 7.90327 35.1608C7.07713 34.3347 6.66406 33.3315 6.66406 32.1513V27.3875H11.4793V5.5L13.7916 7.8175L16.104 5.5L18.4164 7.8175L20.7287 5.5L23.0411 7.8175L25.3586 5.5L27.6761 7.8175L29.9936 5.5L32.3111 7.8175L34.6286 5.5V32.1513C34.6286 33.3315 34.2155 34.3347 33.3894 35.1608C32.5632 35.9869 31.56 36.4 30.3798 36.4H10.9128ZM30.3798 33.825C30.8691 33.825 31.2703 33.6684 31.5836 33.3551C31.8969 33.0418 32.0536 32.6405 32.0536 32.1513V9.61998H14.0543V27.3875H28.7061V32.1513C28.7061 32.6405 28.8627 33.0418 29.176 33.3551C29.4893 33.6684 29.8906 33.825 30.3798 33.825ZM15.9341 15.7485V13.1735H25.2041V15.7485H15.9341ZM15.9341 20.744V18.169H25.2041V20.744H15.9341ZM28.6288 15.7485C28.2769 15.7485 27.9743 15.6219 27.7211 15.3687C27.4679 15.1155 27.3413 14.8129 27.3413 14.461C27.3413 14.1091 27.4679 13.8065 27.7211 13.5533C27.9743 13.3001 28.2769 13.1735 28.6288 13.1735C28.9807 13.1735 29.2833 13.3001 29.5365 13.5533C29.7897 13.8065 29.9163 14.1091 29.9163 14.461C29.9163 14.8129 29.7897 15.1155 29.5365 15.3687C29.2833 15.6219 28.9807 15.7485 28.6288 15.7485ZM28.6288 20.6152C28.2769 20.6152 27.9743 20.4886 27.7211 20.2354C27.4679 19.9822 27.3413 19.6797 27.3413 19.3278C27.3413 18.9758 27.4679 18.6733 27.7211 18.4201C27.9743 18.1669 28.2769 18.0403 28.6288 18.0403C28.9807 18.0403 29.2833 18.1669 29.5365 18.4201C29.7897 18.6733 29.9163 18.9758 29.9163 19.3278C29.9163 19.6797 29.7897 19.9822 29.5365 20.2354C29.2833 20.4886 28.9807 20.6152 28.6288 20.6152ZM10.887 33.825H26.1311V29.9625H9.23904V32.1513C9.23904 32.6405 9.39697 33.0418 9.71285 33.3551C10.0287 33.6684 10.4201 33.825 10.887 33.825Z",
    fill: "#1460E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptLongBlue);
export default __webpack_public_path__ + "static/media/receipt_long_blue.283de04e0e4fd0b7428cbbd3342d01c8.svg";
export { ForwardRef as ReactComponent };